import { render } from "./ClientiDetail.vue?vue&type=template&id=e7404022&scoped=true"
import script from "./ClientiDetail.vue?vue&type=script&lang=js"
export * from "./ClientiDetail.vue?vue&type=script&lang=js"

import "./ClientiDetail.vue?vue&type=style&index=0&id=e7404022&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7404022"]])

export default __exports__